import { render } from "./Parts.vue?vue&type=template&id=33e50c46&scoped=true"
import script from "./Parts.vue?vue&type=script&lang=js"
export * from "./Parts.vue?vue&type=script&lang=js"

import "./Parts.vue?vue&type=style&index=0&id=33e50c46&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e50c46"]])

export default __exports__